import { Input } from "@nextui-org/react";
import { Search } from "lucide-react";
import React from "react";

interface SearchFieldProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

export const SearchField: React.FC<SearchFieldProps> = ({
  value,
  onChange,
  placeholder = "Search...",
  className = "",
}) => {
  return (
    <div className="flex justify-center grow flex-1 items-center">
      <div className="w-[400px]">
        <Input
          className="w-full rounded-md bg-[#F4F4F5]"
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          startContent={<Search className="w-4 h-4 text-gray-500" />}
        />
      </div>
    </div>
  );
};
